import axios from "axios";
import { MascaraCep } from "./MascaraCep";

// Os models guardam o endereço em um único texto:
// "rua, numero - (complemento) - bairro, cidade, estado, cep"

export const ENDERECO_VAZIO = { cep: "", rua: "", numero: "", complemento: "", bairro: "", cidade: "", estado: "" };

export const montarEndereco = (e) => {
    if (!e.rua && !e.cep) return "";
    const partes = [
        [e.rua, e.numero].filter(Boolean).join(", "),
        e.complemento,
        [e.bairro, e.cidade, e.estado, MascaraCep(e.cep)].filter(Boolean).join(", "),
    ];
    return partes.filter((parte) => parte && parte.trim()).join(" - ");
};

// Desfaz montarEndereco; textos fora do padrão vão inteiros para "rua" para não perder nada
export const separarEndereco = (texto) => {
    if (!texto) return { ...ENDERECO_VAZIO };

    const partes = String(texto).split(" - ");
    if (partes.length < 2) return { ...ENDERECO_VAZIO, rua: texto };

    const inicio = partes[0];
    const fim = partes[partes.length - 1].split(",").map((p) => p.trim());
    const complemento = partes.slice(1, -1).join(" - ");
    const separadorNumero = inicio.lastIndexOf(",");

    if (fim.length < 4) return { ...ENDERECO_VAZIO, rua: texto };

    return {
        rua: separadorNumero >= 0 ? inicio.slice(0, separadorNumero).trim() : inicio.trim(),
        numero: separadorNumero >= 0 ? inicio.slice(separadorNumero + 1).trim() : "",
        complemento,
        bairro: fim.slice(0, fim.length - 3).join(", "),
        cidade: fim[fim.length - 3],
        estado: fim[fim.length - 2],
        cep: fim[fim.length - 1].replace(/\D/g, ""),
    };
};

export const enderecoCompleto = (e) => Boolean(e.cep && e.rua && e.numero && e.bairro && e.cidade && e.estado);

// Retorna null quando o CEP não existe
export const buscarCep = async (cep) => {
    const somenteNumeros = String(cep).replace(/\D/g, "");
    if (somenteNumeros.length !== 8) return null;
    const { data } = await axios.get(`https://viacep.com.br/ws/${somenteNumeros}/json/`);
    if (data.erro) return null;
    return { rua: data.logradouro || "", bairro: data.bairro || "", cidade: data.localidade || "", estado: data.uf || "" };
};
